import { createFilterSelectOption } from '../../utils';
import { FilterSegmentSelectInput } from '../FilterSegmentSelectInput';

const booleanValueOptions = [
  createFilterSelectOption('true', 'True'),
  createFilterSelectOption('false', 'False'),
];

const displayText = {
  placeholder: 'Select a value...',
};

type FilterBooleanValueInputProps = {
  value: string;
  onChange: (value: string) => void;
  id: string;
  isDisabled?: boolean;
};

export const FilterBooleanValueInput = ({
  value,
  onChange,
  id,
  isDisabled = false,
}: FilterBooleanValueInputProps) => (
  <FilterSegmentSelectInput
    id={id}
    onSelect={([selectedBooleanValue]) => onChange(selectedBooleanValue?.id || '')}
    options={booleanValueOptions}
    placeholder={displayText.placeholder}
    selectedOptionIds={value.length ? [value] : []}
    isDisabled={isDisabled}
  />
);
